// Third-party packages
import {
	Analytics,
} from '@externals/analytics';
import {
	FeatureFlags,
} from '@externals/featureFlags';
import {
	GoogleTagManagerDestination,
} from '@externals/googleTagManager';
import {
	IdentCheck,
} from '@externals/identCheck';
import {
	RudderStackDestination,
} from '@externals/rudderstack';
import {
	onNavigate,
} from '@helpers/onNavigate';

// Internal libraries (@stonal-tech/*)
import {
	getCurrentApp,
} from '@stonal-tech/lib-front-utils-ts';
import {
	logger,
} from '@config/logger';

// Relative imports
import {
	initJQuery,
} from '../helpers/initJquery';


async function load() {
	logger.setContext({
		app: 'lib-front-tracking',
	});

	// If we don't support localStorage, give up now.
	if (!window.localStorage || !window.sessionStorage) {
		logger.warn('Tracking not supported, localStorage or sessionStorage not supported');
		return;
	}

	initJQuery();

	// We load he base stuff
	const app = getCurrentApp();
	const env = app?.env || 'prod';

	// Then we load our analytics object which allows to add destinations our way
	const analytics = new Analytics();
	analytics.setApp(app);

	// Then we feature flags and the actual integrations:
	const featureFlags = new FeatureFlags(env);
	analytics.addDestination(featureFlags);

	// 1. Rudderstack
	analytics.addDestination(new RudderStackDestination(env));

	// 2. Google Tag Manager
	analytics.addDestination(new GoogleTagManagerDestination());

	// 3. Openobserve (its behavior doesn't rely on identification)
	// if (await featureFlags.isFeatureEnabled('openobserve')) {
	// 	analytics.addDestination(new OpenObserve(analytics));
	// }

	// We expose some things for the dirty browser world
	window.analytics = analytics;

	// Run identification in the background (RudderStack reconciles via anonymousId)
	if (app) {
		const identCheck = new IdentCheck(analytics, app);
		await identCheck.run();
	}

	// Track initial page view immediately
	analytics.page();

	// Track page changes on navigation
	onNavigate(() => {
		let pageApp = getCurrentApp();
		analytics.setApp(pageApp);
		analytics.page();
	});
};

// This is to handle async loading
(async () => {
	await load();
})();
